export const AVIVE_LAYER_KEYS = {
  PLACEHOLDER: 'avive_aed_placeholder',
  HIGHLIGHT: 'avive_aed_highlight',
};

export const createPlaceholder = ({
  phone = '1234567890',
  key = AVIVE_LAYER_KEYS.PLACEHOLDER,
  latitude = 39.766936,
  longitude = -104.918531,
  display = true,
  external_id = 'placeholder',
  rgAddress = {
    street_address: '',
    locality: '',
    region: '',
    postal_code: '',
    country_code: '',
  },
}) => ({
  topic: 'account-id://avive-placeholder',
  type: 'spatial',
  status: '200',
  body: {
    external_id,
    attributes: {
      phone_number: `+${phone}`,
      display: display ? 'True' : 'False',
    },
    shape: {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [longitude, latitude],
          },
          properties: {},
        },
      ],
    },
    date_created: Date.now(),
    is_dynamic: true,
    layer: {
      key,
      source: 'avive',
      name: 'Avive AED Search in Progress',
      category: {
        key: '',
        name: '',
      },
      title: 'Avive Request',
      auto_display: true,
      attributes: {
        $schema: 'http://json-schema.org/draft-04/schema',
        description: '',
        properties: {
          phone_number: {
            required: false,
            title: 'Phone Number',
            type: 'string',
          },
          display: { required: false, title: 'Display', type: 'string' },
        },
        propertiesOrder: [],
        title: 'Avive Search Location',
      },
    },
    rg_address: rgAddress,
  },
});
